import React, { useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import SchoolIcon from "@mui/icons-material/SchoolRounded";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import TransicaoPagina from "../../../componentes/comuns/TransicaoPagina";
import ListaEscolas from "./infoPerfilEscola";
import MantenedoraComponent from "./infoPerfilMant";
import {
  ajustarTamanhoFonteEscola,
  coresTextosGlobais,
  tamanhosPaginasAdministrativas,
  tamanhosControlesGlobais,
} from "../../../estilos/global";

export default function PerfilEscolar() {
  const [aba, setAba] = useState("escolas");
  const [buscas, setBuscas] = useState({ escolas: "", mantenedoras: "" });
  const atualizarBusca = (tipo, valor) =>
    setBuscas((atual) => ({ ...atual, [tipo]: valor }));
  const painel = (ativo) => ({
    display: ativo ? "flex" : "none",
    flexDirection: "column",
    flex: { md: "1 1 0" },
    minHeight: 0,
  });
  return (
    <TransicaoPagina variante="navegacao" data-pagina-rolavel="">
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.4, mb: 1.5 }}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: 1.5,
            bgcolor: "var(--sear-superficie-azul, #e8f4ff)",
            color: "var(--sear-azul, #087cf0)",
            display: "grid",
            placeItems: "center",
            flexShrink: 0,
          }}
        >
          <CorporateFareIcon sx={{ fontSize: 27 }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            component="h1"
            variant="h5"
            sx={{
              color: coresTextosGlobais.tituloPagina,
              fontSize: tamanhosPaginasAdministrativas.tituloPagina,
              fontWeight: 700,
              lineHeight: 1.15,
            }}
          >
            Dados institucionais
          </Typography>
          <Typography
            sx={{
              mt: 0.3,
              color: "var(--sear-texto-secundario, #7b8798)",
              fontSize: tamanhosControlesGlobais.descricao,
              lineHeight: 1.35,
            }}
          >
            Consulte as mantenedoras e escolas vinculadas ao seu acesso.
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 0.2,
          mb: 1.2,
          border: "1px solid var(--sear-borda, #d7e7f7)",
          borderRadius: "7px",
          bgcolor: "var(--sear-superficie-azul, #f7fbff)",
          overflow: "hidden",
        }}
      >
        <Tabs
          value={aba}
          onChange={(_, valor) => setAba(valor)}
          aria-label="Dados institucionais"
          variant="fullWidth"
          sx={{
            minHeight: 48,
            "& .MuiTabs-indicator": {
              height: 3,
              bgcolor: "var(--sear-acao-azul, #087cf0)",
            },
            "& .MuiTab-root": {
              minWidth: 0,
              minHeight: 48,
              textTransform: "none",
              fontWeight: 600,
              fontSize: ajustarTamanhoFonteEscola(14),
              color: "var(--sear-texto-secundario, #6b829e)",
            },
            "& .Mui-selected": {
              color: "var(--sear-azul, #0767d8)",
              bgcolor: "var(--sear-superficie-azul, #eef7ff)",
            },
          }}
        >
          <Tab
            value="escolas"
            icon={<SchoolIcon sx={{ fontSize: 21 }} />}
            iconPosition="start"
            label="Escolas"
            id="aba-escolas"
            aria-controls="painel-escolas"
          />
          <Tab
            value="mantenedoras"
            icon={<AccountBalanceRoundedIcon sx={{ fontSize: 21 }} />}
            iconPosition="start"
            label="Mantenedoras"
            id="aba-mantenedoras"
            aria-controls="painel-mantenedoras"
          />
        </Tabs>
      </Box>
      <Box
        component="section"
        aria-label="Consulta dos dados institucionais"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: 1, md: 2 },
          px: 1.5,
          py: 0.65,
          border: "1px solid var(--sear-borda, #d7e7f7)",
          borderRadius: 2,
          bgcolor: "var(--sear-superficie-azul, #f7fbff)",
        }}
      >
        <TextField
          value={buscas[aba]}
          onChange={(evento) => atualizarBusca(aba, evento.target.value)}
          placeholder={
            aba === "escolas"
              ? "Pesquisar escola..."
              : "Pesquisar mantenedora..."
          }
          size="small"
          inputProps={{
            "aria-label":
              aba === "escolas" ? "Pesquisar escola" : "Pesquisar mantenedora",
          }}
          sx={{
            width: { xs: "100%", md: 460 },
            "& .MuiOutlinedInput-root": {
              bgcolor: "var(--sear-superficie, #fff)",
              borderRadius: 1,
              minHeight: 34,
              fontSize: tamanhosControlesGlobais.campoBusca,
              "& fieldset": { borderColor: "var(--sear-borda, #c9def4)" },
              "& input": { py: 0.8 },
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ fontSize: 18, color: "var(--sear-azul, #087cf0)" }} />
              </InputAdornment>
            ),
            endAdornment: buscas[aba] ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  aria-label="Limpar pesquisa"
                  onClick={() => atualizarBusca(aba, "")}
                >
                  <CloseRoundedIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </InputAdornment>
            ) : undefined,
          }}
        />
      </Box>
      <Box
        role="tabpanel"
        id="painel-escolas"
        aria-labelledby="aba-escolas"
        hidden={aba !== "escolas"}
        sx={painel(aba === "escolas")}
      >
        <ListaEscolas ativo={aba === "escolas"} busca={buscas.escolas} />
      </Box>
      <Box
        role="tabpanel"
        id="painel-mantenedoras"
        aria-labelledby="aba-mantenedoras"
        hidden={aba !== "mantenedoras"}
        sx={painel(aba === "mantenedoras")}
      >
        <MantenedoraComponent
          ativo={aba === "mantenedoras"}
          busca={buscas.mantenedoras}
        />
      </Box>
    </TransicaoPagina>
  );
}
